import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { PublicationModel } from '@domain-group/realhub-backend-api-types'

interface PublicationProps {
  callbacks?: {
    onClick: () => void,
  },
  entity: PublicationModel,
  selected: boolean,
}

const Publication = (props: PublicationProps) => {
  const {
    callbacks,
    entity: { id, title },
    selected,
  } = props

  const { onClick } = callbacks || {}

  return (
    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>
  )
}

export default Publication
